import { RoleGroup, ROLE_GROUPS } from './authorization/roles';
import { HospitalAddOns } from '../services/hospital-add-on.service';

interface quicklinks {
  id: number;
  title: string;
  link: string;
  requiresIPD?: boolean;
  requiresPharmacy?: boolean;
  allowedRoles?: RoleGroup;
}

export const buildHeaderMenu = (addOns: HospitalAddOns): quicklinks[] => {
  const menus: quicklinks[] = [
    { id: 1, title: 'LABEL.DASHBOARD', link: '/dashboard', allowedRoles: ROLE_GROUPS.TenantAndPharmacy },
    { id: 2, title: 'LABEL.PATIENTS', link: '/patient', allowedRoles: ROLE_GROUPS.AllTenant },
    { id: 3, title: 'LABEL.APPOINTMENTS', link: '/appointment', allowedRoles: ROLE_GROUPS.AllTenant },
  ];

  menus.push({ id: 4, title: 'LABEL.QUEUE', link: '/opd/consultation', allowedRoles: ROLE_GROUPS.Consultation });

  if (addOns.ipd) {
    menus.push({
      id: 5,
      title: 'ENTITY.IPD',
      link: '/ipd/management',
      requiresIPD: true,
      allowedRoles: ROLE_GROUPS.AllTenant,
    });
  }

  if (addOns.pharmacy) {
    menus.push({
      id: 6,
      title: 'ENTITY.PHARMACY',
      link: '/pharmacy',
      requiresPharmacy: true,
      allowedRoles: ROLE_GROUPS.Pharmacy,
    });
  }

  return menus;
};
